export default __webpack_public_path__ + "static/media/t-turnover.249c4a61.webp";